import React from 'react';
import Img from 'gatsby-image';
import Vimeo from '@u-wave/react-vimeo';
import { findT } from '@interness/web-core/src/components/_helpers';
import Carousel from '@interness/web-core/src/components/media/Carousel/Carousel';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import ResponsiveIFrame from '@interness/web-core/src/components/structure/iFrame/iFrame';
import Overridable from '@interness/web-core/src/components/Overridable/Overridable';
import BrandPageWrapper from '@interness/ecommerce-addon/src/components/BrandPageWrapper/BrandPageWrapper';
import PageLayout from '../page/base';
import { jsx as ___EmotionJSX } from "@emotion/react";
const BrandPageTemplate = props => {
  const page = props.data.directusBrands.brand;
  const metaData = props.data.allSitePlugin.nodes;
  const translations = findT(page.translations, props.pageContext.lang);
  const typeTranslations = findT(props.data.directusBrandTypes.translations, props.pageContext.lang);
  const headerImage = page.header_images[0].file.localFile.childImageSharp.fluid;
  const seoTitle = `${translations.seo_title ? translations.seo_title : page.display_name} ${typeTranslations.display_name}`;
  let hasEcom = metaData.filter(plugin => plugin.name === '@interness/ecommerce-addon');
  hasEcom = hasEcom.length === 1;
  return ___EmotionJSX(PageLayout, {
    page: page,
    translations: translations,
    seoTitle: seoTitle,
    showCallToAction: true,
    showSubnavigation: true,
    headerImage: headerImage,
    type: page.type.type
  }, page.gallery_images.length > 0 && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", null, ___EmotionJSX(Carousel, null, page.gallery_images.map(image => ___EmotionJSX("figure", {
    key: image.file.localFile.name
  }, ___EmotionJSX(Img, {
    fluid: image.file.localFile.childImageSharp.fluid,
    alt: image.file.localFile.name
  }), image.file.description && ___EmotionJSX("figcaption", {
    style: {
      backgroundColor: '#fff',
      paddingTop: '20px'
    },
    dangerouslySetInnerHTML: {
      __html: image.file.description
    }
  }))))), ___EmotionJSX(Spacer, null)), page.youtube_video_id && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ResponsiveIFrame, {
    src: `https://www.youtube-nocookie.com/embed/${page.youtube_video_id}?rel=0&amp;controls=0`,
    title: `YoutubeVideo`,
    type: 'youtube'
  }), ___EmotionJSX(Spacer, null)), page.vimeo_video_id && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    style: {
      position: 'relative',
      'width': '100%',
      paddingTop: '56.25%'
    }
  }, ___EmotionJSX(Vimeo, {
    responsive: true,
    video: `https://vimeo.com/${page.vimeo_video_id}`,
    dnt: true,
    style: {
      border: '0',
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: '0',
      left: '0'
    }
  })), ___EmotionJSX(Spacer, null)), ___EmotionJSX("div", null, translations.description && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h3", null, page.display_name), ___EmotionJSX(Overridable, {
    fieldName: "translations.description",
    collection: "brand",
    itemId: page.directus_id,
    type: "html_override",
    render: override => {
      return ___EmotionJSX("div", {
        style: {
          textAlign: 'justify'
        },
        dangerouslySetInnerHTML: {
          __html: override ? override : translations.description
        }
      });
    }
  }))), hasEcom && ___EmotionJSX("div", null, ___EmotionJSX(BrandPageWrapper, {
    category: typeTranslations.slug,
    title: `${page.display_name} ${typeTranslations.slug}`,
    manufacturer: page.slug
  })));
};
export default BrandPageTemplate;
const query = "2632987692";